import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-empty-state-style1',
  templateUrl: './empty-state-style1.component.html',
  styleUrls: ['./empty-state-style1.component.scss']
})
export class EmptyStateStyle1Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
